import * as React from 'react';
var DynamicFormOverridesContext = React.createContext({});
export var DynamicFormOverridesProvider = function (_a) {
    var transformSections = _a.transformSections, resolveSections = _a.resolveSections, children = _a.children;
    var value = React.useMemo(function () { return ({ transformSections: transformSections, resolveSections: resolveSections }); }, [resolveSections, transformSections]);
    return (React.createElement(DynamicFormOverridesContext.Provider, { value: value }, children));
};
export var useDynamicFormOverrides = function () {
    return React.useContext(DynamicFormOverridesContext);
};
export var useResolvedSections = function (stepKey, fallbackSections) {
    var resolveSections = useDynamicFormOverrides().resolveSections;
    return React.useMemo(function () { return (resolveSections ? resolveSections(stepKey, fallbackSections) : fallbackSections); }, [fallbackSections, resolveSections, stepKey]);
};
export default DynamicFormOverridesContext;
